module.exports = __webpack_public_path__ + "static/media/A2_10.4b541e3b.png";